import {jsonProperty} from "json-mapper-reflect";
import * as moment from "moment";
import {AvdbIssue} from "./avdb-issue";

export class DeviceAvdbInstalledIssue extends AvdbIssue {
	@jsonProperty()
	seriesID: number;

	// If we're getting this information from the cloud apps, it is capitalized differently
	@jsonProperty()
	set seriesId(value: number) {
		if (value) {
			this.seriesID = value;
		}
	}

	@jsonProperty()
	installedAt: moment.Moment;

	constructor(data?: Partial<DeviceAvdbInstalledIssue>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	critical: Boolean;
}
